import { trackingMiddleware } from '@vfde-sails/tracking';
import { configureStore } from '@reduxjs/toolkit';
import gladosApi from './container/App/api/glados';
import appSlice from './container/App/slice';
import appListener from './container/App/listener';
import {
    overlayApi,
    overlaySlice,
} from '@vfde-sails/overlay';

export const store = configureStore({
    reducer: {
        [appSlice.reducerPath]: appSlice.reducer,
        [gladosApi.reducerPath]: gladosApi.reducer,
        [overlaySlice.reducerPath]: overlaySlice.reducer,
        [overlayApi.reducerPath]: overlayApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(appListener.middleware) // Listener goes first because of special actions in it
        .concat(gladosApi.middleware, overlayApi.middleware, trackingMiddleware),
});

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Infer AppDispatch
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Export dispatch function
 */
export const useDispatch = () => store.dispatch;
